import EventBus from "../utility/Eventbus";
import { parseJwtPayload } from "./parseJwt";
import store from "../store";
import router from "../router";

class Authentication {
  constructor(endpoint) {
    this.endpoint = endpoint;
    window.addEventListener("storage", this.syncLogout);
    if (this.isLoggedIn()) {
      const expiration = this.getExpiration();

      if (expiration && expiration < new Date()) {
        this.logout();
      }
    }
  }

  syncLogout(event) {
    if (event.key === "logout") {
      router.go({ path: "/login" });
    }
  }

  async login(userName, pass, environment) {
    try {
      const response = await fetch(`${this.endpoint}/signin`, {
        method: "POST",
        body: JSON.stringify({
          userName,
          pass,
          environment,
        }),
      });
      if (!response.ok) {
        switch (response.status) {
          case 401:
            EventBus.$emit("snackbar", "Unauthorized");
            return false;
          case 400:
            EventBus.$emit(
              "snackbar",
              "Bad Request: something went wrong when submitting the request, please try again and contact support if this persists"
            );
            return false;
          default:
            throw new Error(response);
        }
      }
      const payload = await response.json();

      if (!payload.accessToken) {
        return Promise.reject(payload);
      }

      this.setToken(payload.accessToken);
      return true;
    } catch (error) {
      return false;
    }
  }

  logout() {
    store.commit("setToken", undefined);
    localStorage.removeItem("accessToken");
    // to support logging out from all windows
    window.localStorage.setItem("logout", Date.now());
  }

  getExpiration() {
    const token = this.getToken();
    if (token) {
      const expiration = new Date(parseJwtPayload(token).exp * 1000);
      return expiration;
    } else {
      return undefined;
    }
  }

  isLoggedIn() {
    return !!this.getToken();
  }

  setToken(token) {
    //store.commit("setToken", token);
    localStorage.setItem("accessToken", token);
  }

  getToken() {
    //return store.state.inMemoryToken;
    return localStorage.getItem("accessToken");
  }

  getUser() {
    const token = this.getToken();
    if (token) {
      return parseJwtPayload(token);
    } else {
      return false;
    }
  }

  async fetchGET(endpoint, qs) {
    // could be merged to the fetch function

    try {
      const qsStringified = Object.entries(qs)
        .map(([key, value]) => {
          return `${key}=${value}`;
        })
        .join("&");

      const response = await fetch(
        `${this.endpoint}/${endpoint}?${qsStringified}`,
        {
          headers: {
            Authorization: this.getToken(),
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        switch (response.status) {
          case 401:
            EventBus.$emit("snackbar", "Unauthorized");
            this.logout();
            return undefined;
          case 400:
            EventBus.$emit(
              "snackbar",
              "Bad Request: Something went wrong when submitting the request, please try again and contact support if this persists"
            );
            return undefined;
          default:
            EventBus.$emit(
              "snackbar",
              "Error: Something went wrong, please try again and contact support if this persists"
            );
            return undefined;
        }
      }
      const payload = await response.json();
      return payload;
    } catch (error) {
      return undefined;
    }
  }

  /** A fetch methods that handles inserting the Authorization header and also emits fail events */
  async fetch(endpoint, method, body = undefined) {
    try {
      const response = await fetch(`${this.endpoint}/${endpoint}`, {
        method: method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
          Authorization: this.getToken(),
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        switch (response.status) {
          case 401:
            EventBus.$emit("snackbar", "Unauthorized");
            this.logout();
            return undefined;
          case 400:
            EventBus.$emit(
              "snackbar",
              "Bad Request: Something went wrong when submitting the request, please try again and contact support if this persists"
            );
            return undefined;
          default:
            EventBus.$emit(
              "snackbar",
              "Error: Something went wrong, please try again and contact support if this persists"
            );
            return undefined;
        }
      }
      const payload = await response.json();
      return payload;
    } catch (error) {
      return undefined;
    }
  }
}

export default new Authentication(process.env.VUE_APP_BASE_URL);
